import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-14" aria-labelledby="antes-despues" data-id="element-68" data-mp="26lutcc89j2bx">
      <div className="mx-auto w-full max-w-4xl" data-id="element-69" data-mp="22l13hdb9fdge">
        <h2 id="antes-despues" className="text-center font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-70" data-mp="22mc6hawvsh6g">
          De la incertidumbre clínica a la confianza en cada decisión
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-71" data-mp="2qabuw46pzvhv">
          Cada algoritmo, protocolo y herramienta fue diseñado para responder una
          sola pregunta:{' '}
          <span className="font-semibold text-navy" data-id="element-72" data-mp="1euwxizaln1m8">
            ¿Cuál es el siguiente paso con este paciente?
          </span>
        </p>

        <div className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-73" data-mp="19vajwoquzjcw">
          <div className="rounded-3xl border border-navy/10 bg-white p-5" data-id="element-74" data-mp="175m638vdxogb">
            <h3 className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-widest text-navy/50" data-id="element-75" data-mp="173jggpy59xc4">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-navy/10" data-id="element-76" data-mp="y4xzv0c8gsdz">
                <XIcon className="h-3.5 w-3.5 text-navy/60" aria-hidden="true" data-id="element-77" data-mp="133ios3m1bpn4" />
              </span>
              Antes
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-78" data-mp="oe314whsw0bn">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-[15px] leading-snug text-navy/60" data-id="element-79" data-mp="t6mqeqpuojwa">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/35" aria-hidden="true" data-id="element-80" data-mp="fezjlwya7sz9" />
                  <span className="line-through decoration-navy/20" data-id="element-81" data-mp="jdfc2gd4ttk2">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-brandred/25 bg-white p-5 shadow-lg shadow-brandred/5" data-id="element-82" data-mp="ae20ni5g6uwp">
            <h3 className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-widest text-brandred" data-id="element-83" data-mp="2c52j3tmmc147">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brandred-tint" data-id="element-84" data-mp="27bzjp4v5txg3">
                <CheckIcon className="h-3.5 w-3.5 text-brandred" aria-hidden="true" data-id="element-85" data-mp="23c796mm7hh83" />
              </span>
              Después
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-86" data-mp="2v3n6pbpawod3">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-[15px] font-medium leading-snug text-navy" data-id="element-87" data-mp="2r1t8da2kvwg3">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brandred" aria-hidden="true" data-id="element-88" data-mp="2m0vs5314pch8" />
                  <span data-id="element-89" data-mp="1antdidilawzp">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8" data-id="element-90" data-mp="15n5kxnepq83d">
          <CTAButton label="Quiero decidir con esta claridad" data-id="element-91" data-mp="15mvxo7l1yf1d" />
        </div>
      </div>
    </section>;
}